import {NgModule} from '@angular/core';
import {HasRoleDirective} from './directives/hasRole.directive';


@NgModule({
  declarations: [
		HasRoleDirective,
    
  ],
  imports: [
  ],
	exports: [
		HasRoleDirective,
    
	]
})
export class SharedModule { }
